import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';

import styles from './DataBuilderGrid.module.css';

export const DataBuilderGrid = ({
  columns,
  style,
  className,
  children,
}: {
  columns: 'responsive' | '2' | '3';
  style?: CSSProperties;
  className?: string;
  children: ReactNode;
}) => {
  return (
    <div
      className={classNames(
        styles.DataBuilderGrid,
        columns === 'responsive' && styles.DataBuilderGridResponsive,
        columns === '2' && styles.DataBuilderGrid2Cols,
        columns === '3' && styles.DataBuilderGrid3Cols,
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
};
